export default {
  simplified: () => import("/usr/src/nuxt-app/layouts/Simplified.vue").then(m => m.default || m),
  "components-simplified-footer": () => import("/usr/src/nuxt-app/layouts/components/SimplifiedFooter.vue").then(m => m.default || m),
  "components-simplified-header": () => import("/usr/src/nuxt-app/layouts/components/SimplifiedHeader.vue").then(m => m.default || m),
  default: () => import("/usr/src/nuxt-app/layouts/default.vue").then(m => m.default || m)
}